(function ($) {
	var isValidDate = void 0;

	require(['moment'], function (moment) {
		isValidDate = function (value) {
			return moment(value, 'YYYY-MM-DD', true).isValid();
		};
	});

	if ($.fn.SurveyFieldValidator) {
		throw new Error('SurveyFieldValidator plugin is already defined');
	}

	$.fn.SurveyFieldValidator = function () {
		return $.extend(this, $.fn.SurveyFieldValidator.API);
	};

	$.fn.SurveyFieldValidator.API = {
		validate: function (fields, labels) {
			var that = this;
			var validated = true,
			    value = void 0,
			    month = void 0,
			    year = void 0,
			    visible = true;

			$.each(fields, function (_, field) {
				value = undefined;
				month = undefined;
				year = undefined;

				// TODO: remove this hack to check if question is visible
				visible = $(field.element).is(':visible');

				// This switch will validate the different question types and show errors when needed
				switch (field.type) {
					case 'overall_score':
						value = $(field.element).find('input').val();

						if (visible && field.mandatory && (!value || value === '0')) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.no_score);
							validated = false;
						} else if (visible && field.mandatory && (!$.isNumeric(value) || $.isNumeric(value) && parseInt(value) < 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.invalid_score);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'score':
						value = $(field.element).find('input').val();

						if (visible && field.mandatory && (!value || value === '0')) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else if (visible && value && value.length > 0 && (!$.isNumeric(value) || $.isNumeric(value) && parseInt(value) < 0 && parseInt(value) !== -1)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.invalid_score);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'title':
						value = $(field.element).find('input').val();

						// Max permitted length
						if (visible && value && value.length > 255) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.title_too_long);
							validated = false;
						} else if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'review':
						value = $(field.element).find('textarea#text').val();

						// Max permitted length
						if (visible && value && value.length > REVIEW_LENGTH) {
							// eslint-disable-line no-undef
							that.displayErrorMessage(field.element, '.not_valid', true, labels.text_too_long);
							validated = false;
						} else if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;

					case 'age':
						value = $(field.element).find('input').val();

						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else if (visible && value && value.length > 0 && (!$.isNumeric(value) || $.isNumeric(value) && parseInt(value) < 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.invalid_age);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;

					case 'traveller':
						value = $(field.element).find('input').val();

						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;

					case 'nationality':
						value = $(field.element).find('select').val();

						// Max permitted length
						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'recommend':
						value = $(field.element).find('input').val();

						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'text':
						value = $(field.element).find('input').val();

						// Max permitted length
						if (visible && value && value.length > 255) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.short_text_too_long);
							validated = false;
						} else if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'number':
						value = $(field.element).find('input').val();

						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else if (visible && value && value.length > 0 && !$.isNumeric(value)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.value_not_number);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'phone':
						value = $(field.element).find('input').val();
						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'dropdown':
						value = $(field.element).find('select').val();

						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'nps':
					case 'net_promoter_score':
						value = $(field.element).find('input').val();

						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'year_month':
						// eslint-disable-line no-case-declarations
						year = $(field.element).find('.year select').val();
						var validDate = true;

						if (visible && field.mandatory && (!year || year.length !== 4 || !$.isNumeric(year))) {
							that.displayErrorMessage($(field.element), '.not_valid', true, labels.required_field);
							validated = false;
							validDate = false;
						} else {
							that.displayErrorMessage($(field.element), '.not_valid', false);
						}

						month = $(field.element).find('.month select').val();

						if (visible && field.mandatory && (!month || month.length !== 2 || !$.isNumeric(month) || $.isNumeric(month) && (month < 1 || month > 12))) {
							that.displayErrorMessage($(field.element), '.not_valid', true, labels.required_field);
							validated = false;
						} else if (validDate) {
							that.displayErrorMessage($(field.element), '.not_valid', false);
						}

						break;
					case 'longText':
						value = $(field.element).find('textarea').val();

						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else if (visible && value && value.length > 4000) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.field_too_long);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'checkboxes':

						if (visible && field.mandatory && $(field.element).find('input:checked').length <= 0) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'radios':
						value = $(field.element).find('input:checked').val();

						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'date':
						value = $(field.element).find('input').val();

						if (visible && field.mandatory && (!value || value.length === 0)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.required_field);
							validated = false;
						} else if (visible && (value || value.length > 0) && !isValidDate(value)) {
							that.displayErrorMessage(field.element, '.not_valid', true, labels.error_value_not_date);
							validated = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid', false);
						}

						break;
					case 'personal':
						// eslint-disable-line no-case-declarations
						var name = $(field.element).find('#guest_name').val();
						var email = $(field.element).find('#guest_email').val();
						var validName = true;

						// Remove messages at the beginning
						that.displayErrorMessage(field.element, '.not_valid_guest_email', false, '.guest_name, .guest_email');

						if (visible && name && name.length > 255) {
							that.displayErrorMessage(field.element, '.not_valid_guest_name', true, labels.invalid_guest_name, '.guest_name');
							validated = false;
							validName = false;
						} else {
							that.displayErrorMessage(field.element, '.not_valid_guest_name', false, '', '.guest_name');
						}

						if ($(field.element).find('#guest_email').length > 0 && visible && (!email && field.mandatory || email && !that.validateEmail(email))) {
							that.displayErrorMessage(field.element, '.not_valid_guest_email', true, labels.no_guest_email, '.guest_email');
							validated = false;
						} else if ($(field.element).find('#guest_email').length > 0 && visible && email && email.length > 255) {
							that.displayErrorMessage(field.element, '.not_valid_guest_email', true, labels.guest_email_too_long, '.guest_email');
							validated = false;
						} else if (validName) {
							that.displayErrorMessage(field.element, '.not_valid_guest_email', false, '', '.guest_email');
						}

						break;
					default:
						break;
				}
			});

			return validated;
		},


		// Validates email
		validateEmail: function (email) {
			var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(email);
		},


		// Shows error in the questionnaire
		displayErrorMessage: function (mainElement, selector, showError, message, boxSelector) {
			if (showError) {
				// TODO: maybe better if no hardcoded class?
				if (boxSelector) {
					$(mainElement).find(boxSelector).addClass('has-error');
				} else {
					$(mainElement).addClass('has-error');
				}
				$(mainElement).find(selector).html(message);
				$(mainElement).find(selector).show();

				var scrollOffset = 100;
				$('html, body').animate({
					scrollTop: $('.has-error').offset().top - scrollOffset
				}, 0);
			} else {
				// TODO: maybe not hardcoded class?
				if (boxSelector) {
					$(mainElement).find(boxSelector).removeClass('has-error');
				} else {
					$(mainElement).removeClass('has-error');
				}
				$(mainElement).find(selector).empty();
				$(mainElement).find(selector).hide();
			}
		}
	};
})(jQuery);